import styled, { css } from "styled-components";
import { ITheme, Theme } from "../../shared/types";
import { IUploadStatus } from "./NewOrder";

export const Card = styled.div`
  -webkit-box-shadow: 5px 5px 15px -3px ${(p: ITheme) => p.theme.color[300]};
  box-shadow: 5px 5px 15px -3px ${(p: ITheme) => p.theme.color[300]};
  background-color: ${(p: ITheme) => p.theme.color.background};
  border-radius: 5px;
`;
export const DataGridWrapper = styled(Card)`
  margin-bottom: 24px;
  width: 100%;
`;
export const DataGridContainer = styled.div`
  height: calc(100vh - 210px);
  min-height: 320px;
`;
export const Status = styled.div<{ status: "pending" | "active" | "passive" }>`
  padding: 3px 5px;
  border-radius: 5px;
  background-color: ${(props) =>
    props.status === "passive"
      ? "rgb(201, 75, 75, 0.5)"
      : props.status === "pending"
      ? "rgb(80, 235, 23, 0.2)"
      : "rgb(58, 143, 43, 0.2)"};
  color: ${(props) =>
    props.status === "passive"
      ? "rgb(173, 26, 26)"
      : props.status === "pending"
      ? "rgb(125, 168, 5)"
      : "rgb(29, 87, 19)"};
`;
export const ActionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  .btn {
    background-color: white;
    border: 1px solid gray;
    border-radius: 5px;
    padding: 3px 6px;
    cursor: pointer;
  }
  .viewBtn {
    color: #5949d1;
  }
  .deleteBtn {
    color: rgb(173, 26, 26);
  }
`;
export const AddUser = styled(Card)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  .title {
    text-align: center;
    font-size: 20px;
    padding: 12px;
    font-weight: 500;
    color: ${(props: ITheme) => props.theme.color[900]};
  }
  .add {
    font-size: 16px;
    padding: 5px 10px;
    border: 1px solid ${(props: ITheme) => props.theme.color[900]};
    border-radius: 3px;
    cursor: pointer;
    outline: none;
    background: ${(props: ITheme) => props.theme.color.background};
    color: ${(props: ITheme) => props.theme.color[900]};
  }
  .exportBtn {
    background-color: white;
    border: 1px solid gray;
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
    color: #5949d1;
  }

`;

export const Container = styled(Card)`
  display: flex;
  padding: 40px;
  margin-bottom: 24px;
`;

export const Left = styled.div`
  flex: 1;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  gap: 10px;
  .img {
    width: 200px;
    height: auto;
    object-fit: cover;
    // border-radius: 50%;
    background-color: ${(p: ITheme) => p.theme.color[200]};
  }
`;
export const Right = styled.div`
  flex: 3;
  display: flex;
`;

export const HeaderTitle = styled(Card)`
  text-align: center;
  font-size: 26px;
  padding: 12px;
  font-weight: 700;
  color: ${(props: ITheme) => props.theme.color[800]};
`;

export const InputForm = styled.form`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 36px;
  .file {
    width: 40%;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .icon {
    font-size: 36px;
    cursor: pointer;
  }
  .input {
    width: 40%;
  }
  .inputField {
    width: 100%;
    background-color: inherit;
    border: none;
    border-bottom: 1px solid ${(p: ITheme) => p.theme.color[800]};
    padding: 8px 0px;
    font-size: 16px;
    outline: none;
  }
  .inputTitle {
    font-weight: 200;
    padding : 5px 0px;
  }
  .full-width {
    width: 100%;
    padding: 5px 8%;
  }
  .descriptionField {
    width: 100%;
    border-width: 0px;
    border-bottom: 1px solid #010101;
  }
  .descriptionField:focus {
    /* Add your focus styles here */
    border-bottom: 2px solid #0000FF; /* example: change bottom border to blue and make it thicker */
    outline: none; /* You might want to remove the default outline */
  }
  .submit {
    width: 50%;
    padding: 6px;
    border: none;
    border-radius: 3px;
    color: ${(p: ITheme) => p.theme.color.background};
    font-size: 18px;
    font-weight: 700;
    background-color: ${(p: ITheme) => p.theme.color[800]};
    cursor: pointer;
  }
`;

interface ISubmitButtonProps {
  theme: Theme;
  uploadStatus?: IUploadStatus;
}
export const SubmitButton = styled.button<ISubmitButtonProps>`
  width: 50%;
  padding: 8px 24px;
  border: none;
  border-radius: 3px;
  color: ${(p: ITheme) => p.theme.color.background};
  font-size: 18px;
  font-weight: 700;
  background-color: ${(p: ITheme) => p.theme.color[800]};
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
    background-color: ${(p: ITheme) => p.theme.color[500]};
  }
  /* ${(props) => (props.uploadStatus === "UPLOADED" ? css`` : css``)} */
`;

// Order View Components
export const OrderInfoContainer = styled.div`
  display: flex;
  gap: 32px;
  align-items: flex-start;
`;

export const OrderInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OrderInfoLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #666;
`;

export const OrderStatusBadge = styled.div<{ status?: string }>`
  font-size: 14px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 5px;
  text-transform: capitalize;
  background-color: ${(props) =>
    props.status === 'approved' || props.status === 'succeeded'
      ? 'rgb(58, 143, 43, 0.2)'
      : props.status === 'pending'
      ? 'rgb(80, 235, 23, 0.2)'
      : 'rgb(201, 75, 75, 0.5)'};
  color: ${(props) =>
    props.status === 'approved' || props.status === 'succeeded'
      ? 'rgb(29, 87, 19)'
      : props.status === 'pending'
      ? 'rgb(125, 168, 5)'
      : 'rgb(173, 26, 26)'};
`;

export const StatusBadge = styled.div<{ status?: string }>`
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
  text-transform: capitalize;
  display: inline-block;
  background-color: ${(props) =>
    props.status === 'approved' || props.status === 'succeeded'
      ? 'rgb(58, 143, 43, 0.2)'
      : props.status === 'pending'
      ? 'rgb(80, 235, 23, 0.2)'
      : 'rgb(201, 75, 75, 0.2)'};
  color: ${(props) =>
    props.status === 'approved' || props.status === 'succeeded'
      ? 'rgb(29, 87, 19)'
      : props.status === 'pending'
      ? 'rgb(125, 168, 5)'
      : 'rgb(173, 26, 26)'};
`;

export const OrderInfoValue = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

export const OrderInfoValueBadge = styled.div`
  font-size: 16px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 6px;
  color: #333;
  background-color: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.08);
  display: inline-block;
`;

export const OrderStatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const OrderActionsContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const ApproveButton = styled.button`
  width: auto;
  padding: 10px 24px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: background-color 0.2s;
  &:hover {
    background-color: #45a049;
  }
`;

export const DeleteButton = styled.button`
  width: auto;
  padding: 10px 24px;
  background-color: #d32f2f;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: background-color 0.2s;
  &:hover {
    background-color: #c62828;
  }
`;

export const OrderMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 24px 16px 16px;
`;

export const OrderMessageActions = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const SaveMessageButton = styled.button`
  width: auto;
  padding: 10px 24px;
  background-color: #5949d1;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: background-color 0.2s;
  &:hover {
    background-color: #4a3bb8;
  }
`;

export const OrderMessageLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #666;
`;

export const OrderMessageTextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px;
  font-size: 14px;
  font-family: inherit;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s;
  &:focus {
    border-color: #5949d1;
  }
`;